import {
  createCalculationCardset,
  createCalculationResultCardset
} from '@/utils/create-cardset';
import symbolSubsetSelector from '@/utils/symbol-subset-selector';
import { shuffle } from '@/utils/lib';
import x8 from './x8.json';

export default () => {
  const level1 = symbolSubsetSelector(x8, 3, shuffle);
  const level2 = symbolSubsetSelector(x8, 4, shuffle);
  const level3 = symbolSubsetSelector(x8, 6, shuffle);
  const level4 = symbolSubsetSelector(x8, 8, shuffle);
  const level5 = x8;

  return {
    '8x1L1': createCalculationCardset(level1),
    '8x1L1result': createCalculationResultCardset(level1),
    '8x1L2': createCalculationCardset(level2),
    '8x1L2result': createCalculationResultCardset(level2),
    '8x1L3': createCalculationCardset(level3),
    '8x1L3result': createCalculationResultCardset(level3),
    '8x1L4': createCalculationCardset(level4),
    '8x1L4result': createCalculationResultCardset(level4),
    '8x1L5': createCalculationCardset(level5),
    '8x1L5result': createCalculationResultCardset(level5)
  };
};
